import type { LangStrings } from './en';

export const zh: LangStrings = {
  back: '返回',
  next: '下一关',
  retry: '重试',
  replay: '重玩',
  sector: '扇区',
  sectors: '扇区',
  levels: '关卡',
  cleared: '已通关',
  open: '开放',
  locked: '锁定',
  tba: 'TBA',
  slot_reserved: '保留槽位',
  sfx_on: '音效 开',
  sfx_off: '音效 关',
  reset_progress: '清除进度',
  wiped_reloading: '已清除, 重新加载…',
  got_it: '› 明白 ‹',

  boot_eyebrow: '级联协议  //  BUILD',
  boot_tagline: '一次点击。一次级联。没有重来。',
  boot_subtitle: '信号崩壊  ·  CASCADE LOGIC',
  boot_cta: '› 点击启动 ‹',
  boot_region: '区域 ▣ /7',
  boot_top_left: 'HAYTERWAVE//SYSCORE',
  boot_top_right_status: '0xC7A5 // 在线',

  menu_header_subtitle: 'NØDUS / 扇区.选择',
  menu_engine_label: '信号崩塌引擎',
  menu_signals_down: '信号击破',
  menu_tap_chapter: '点击章节进入',
  menu_language_label: '语言',

  chapter_signals_down: '信号击破',
  chapter_tba_label: '0xTBA',
  chapter_coda_name: '尾声',
  chapter_coda_tagline: '没有新东西。全部组合。',

  hud_tap_to_breach: '▾  点击任一节点突破  ▾',
  hud_tap_to_skip: "跳过  ▸▸",
  hud_drag_zoom_help: '拖动平移 · 滚轮/捏合缩放',
  hud_required: '必需',
  hud_core_online: '核心在线',
  hud_core_down: '核心击破',

  tut_tap_any_node: '点击任一节点',
  tut_they_all_work: '这里全都可以',

  brief_eyebrow: '◂ 任务简报 ▸',
  brief_title: '一次点击。\n一次级联。',
  brief_line_1: '› 你只有一次点击。',
  brief_line_2: '› 它会引发网络中的连锁反应。',
  brief_line_3: '› 击破每个必需节点（青色菱形）以获胜。',
  brief_line_4: '› 绝不让脉冲触及受保护节点（红色）。',
  brief_begin: '› 开始简报 ‹',

  result_win_headline: '系统崩塌',
  result_fail_headline: '级联失败',
  result_first_clear: '› 首次通关 ‹',
  result_try_label: '› 尝试',
  result_cleared_suffix: '已通关',
  result_aborted_suffix: '运行中止',
  result_win_body_template: '{ticks} 滴答。{nodes} 个节点击破。',

  fail_protected_overload: '受保护节点过载。级联触碰了不该触碰的位置。',
  fail_forbidden_trigger: '禁线传输了信号。触发了严重警报。',
  fail_required_not_reached: '必需节点未收到脉冲。链条没有到达。',
  fail_required_under_threshold: '必需节点未获得足够脉冲。第一发衰减后第二发才到达。',
  fail_core_not_collapsed: '核心幸存。级联在抵达之前消散。',
  fail_core_under_threshold: '核心收到脉冲但不够, 未及时收敛。',
  fail_core_shielded: '核心脉冲被阻挡。一个护盾仍在工作。',
  fail_chain_died: '在到达任何目标之前链条已死。',
  fix_protected_overload: '选择级联永远不会触及红色危险的起点。先描出每个起点的下游。',
  fix_forbidden_trigger: '避开会向红色虚线发火的起点。一旦触碰立即警报。',
  fix_required_not_reached: '你的起点没有连到该节点。看箭头, 定向线只走一个方向。',
  fix_required_under_threshold: '找到能送两个脉冲到该节点的路径, 分裂器或两条汇聚路径通常足够。',
  fix_core_not_collapsed: '需要更多向核心的汇聚。分裂器、电容器、继电器就是为此存在。',
  fix_core_under_threshold: '脉冲到得太慢。用分裂器叠加，或让所有脉冲在同一滴答到达。',
  fix_core_shielded: '在致命一击落下前拆掉每个护盾。延迟线晚到是一种干净的做法。',
  fix_chain_died: '你的起点只连到一个节点。选网中央的节点。',

  popup_new_node: '◂ 新节点类型 ▸',
  popup_new_wire: '◂ 新线缆类型 ▸',

  node_normal_title: '节点',
  node_normal_tagline: '基本单位。点击启动级联。',
  node_normal_b1: '在第一个脉冲到达时崩塌。',
  node_normal_b2: '向每条开放的输出线发射脉冲。',
  node_normal_b3: '无阈值, 一击即逝。',

  node_required_title: '必需节点',
  node_required_tagline: '必须击破每个必需节点才能获胜。',
  node_required_b1: '青色菱形。空闲时微弱脉动便于识别。',
  node_required_b2: '部分需要在同一窗口收到 2+ 脉冲。',
  node_required_b3: '漏掉一个，运行失败。',
  node_required_note: '节点周围的小点环显示其充能进度。',

  node_protected_title: '受保护节点',
  node_protected_tagline: '触碰它，整个运行即死。',
  node_protected_b1: '红色危险十字。带角括标记。',
  node_protected_b2: '任何脉冲触及它都会立即失败。',
  node_protected_b3: '规划一条永不喂入它的路径。',

  node_relay_title: '继电器',
  node_relay_tagline: '崩塌时打开锁定线。',
  node_relay_b1: '金色雪佛龙。目标显示为虚线锁定线。',
  node_relay_b2: '继电器倒下时，其锁定线接通。',
  node_relay_b3: '可用于打开通往守卫节点的路径。',

  node_shield_title: '护盾',
  node_shield_tagline: '保镖。替另一个节点挨打。',
  node_shield_b1: '环绕受护节点的绿色六角环。',
  node_shield_b2: '对受护节点的直接脉冲毫无效果。',
  node_shield_b3: '先击碎护盾, 再送出致命一击。',
  node_shield_note: '延迟线（金色虚线）非常适合护盾后的精准一击。',

  node_splitter_title: '分裂器',
  node_splitter_tagline: '在所有输出上放大脉冲。',
  node_splitter_b1: '品红分叉。1 脉冲入 → 每个输出 N 脉冲。',
  node_splitter_b2: 'X 标记显示分裂系数。',
  node_splitter_b3: '为高阈值核心提供所需的多重打击。',

  node_capacitor_title: '电容器',
  node_capacitor_tagline: '存储脉冲并重新发射, 缓冲区。',
  node_capacitor_b1: '黄色电容符号。将脉冲转发 3 滴答后。',
  node_capacitor_b2: '当作路线中内置的延迟使用。',
  node_capacitor_b3: '让后续脉冲在护盾倒下之后到达。',

  node_core_title: '核心',
  node_core_tagline: '目标。高阈值，快速衰减。',
  node_core_b1: '紫色反应堆。需要许多汇聚脉冲才会倒下。',
  node_core_b2: '充能会衰减, 脉冲必须密集到达。',
  node_core_b3: '常被护盾守护。先击碎再灌入核心。',
  node_core_note: '含核心的关卡通过崩塌核心获胜。必需节点（如有）仍计入。',

  wire_directional_title: '定向线',
  wire_directional_tagline: '单向导体。带箭头的青色。',
  wire_directional_b1: '脉冲仅沿箭头方向传播。',
  wire_directional_b2: '从箭头反方向点击不会流通。',
  wire_directional_b3: '从起点跟随箭头追到尾。',

  wire_delay_title: '延迟线',
  wire_delay_tagline: '金色虚线。脉冲 3 滴答后到达。',
  wire_delay_b1: '用于同步, 在护盾倒下后落下脉冲。',
  wire_delay_b2: '或在高阈值节点上叠加两次脉冲。',
  wire_delay_b3: '时机错了，第一发会先衰减。',

  wire_locked_title: '锁定线',
  wire_locked_tagline: '灰色虚线 + 挂锁。直到有东西打开才通。',
  wire_locked_b1: '每条锁定线由继电器控制。',
  wire_locked_b2: '继电器崩塌时，其锁定线弹开。',
  wire_locked_b3: '别浪费一次点击直接给锁定线供电。',

  wire_forbidden_title: '禁线',
  wire_forbidden_tagline: '红色虚线 + 十字。触碰 = 立即失败。',
  wire_forbidden_b1: '任何脉冲, 包括过境脉冲, 都会触发警报。',
  wire_forbidden_b2: '留意每个起点的输出线上是否有它。',
  wire_forbidden_b3: '选择路径绝不触及红色的起点。',

  wire_burn_title: '烧毁线',
  wire_burn_tagline: '黄铜橙。一次性导体, 脉冲后烧毁。',
  wire_burn_b1: '恰好运载一个脉冲，然后永久死亡。',
  wire_burn_b2: '仔细规划这唯一一次使用, 没有第二次。',
  wire_burn_b3: '一旦烧毁，任何级联都无法穿过。',

  callout_required_crashed: '必需节点击破',
  callout_core_breached: '核心突破',
  callout_shield_dropped: '护盾坠落',
  callout_relay_opened: '继电器开启',
  callout_protected_hit: '受保护节点被击',

  // ── Beta: settings ─────────────────────────────────────────
  menu_settings: 'SETTINGS',
  settings_title: 'SETTINGS',
  settings_sound: 'Sound',
  settings_haptics: 'Haptics',
  settings_haptics_note: 'device only',
  settings_on: 'ON',
  settings_off: 'OFF',
  settings_replay_tutorials: 'Replay tutorials',
  settings_reset_progress: 'Reset all progress',
  settings_reset_confirm: 'TAP AGAIN TO WIPE',
  settings_done: 'DONE',

  // ── Beta: achievements / share ─────────────────────────────
  menu_achievements: 'AWARDS',
  ach_title: 'ACHIEVEMENTS',
  ach_new: 'ACHIEVEMENT UNLOCKED',
  ach_locked: 'LOCKED',
  share_button: 'SHARE',
  share_copied: 'Copied to clipboard',

  // ── Beta: daily challenge ──────────────────────────────────
  daily_title: 'DAILY',
  daily_tagline: 'One fresh puzzle every day. Keep the streak alive.',
  daily_new: 'NEW TODAY',
  daily_keep: 'KEEP IT ALIVE',
  menu_play_first: 'LEVEL 1 FIRST',
  daily_done: 'SOLVED ✓',
  daily_solved: 'DAILY SOLVED',
  daily_streak: 'STREAK',

  // ── Beta: ads / lives / hints / stats ───────────────────────
  ad_label: 'ADVERTISEMENT',
  ad_house_tagline: 'One tap. One breach. Infinite levels.',
  ad_rewarded_watching: 'Watch to earn your reward',
  ad_interstitial_watching: 'Your run continues in a moment',
  ad_rewarded_done: 'Reward unlocked',
  ad_interstitial_done: 'Thanks for playing',
  ad_reward_in: 'Reward in {n}s',
  ad_claim: 'CLAIM',
  ad_continue: 'CONTINUE',
  lives_label: 'LIVES',
  run_over_headline: 'OUT OF LIVES',
  run_over_body: 'Your run is on the line. Watch an ad for a life, or bank this run.',
  watch_for_life: 'AD  +1 LIFE',
  bank_run: 'BANK RUN',
  life_lost: '-1 LIFE',
  hint_button: 'HINT',
  hint_confirm_title: 'WATCH AD FOR A HINT?',
  hint_confirm_body: 'Rules out one breach point that does NOT solve this level. It never shows you the answer.',
  hint_yes: 'WATCH AD',
  hint_removed: 'One wrong breach point ruled out',
  hint_none_left: 'Nothing left to rule out',
  no_thanks: 'NO THANKS',
  stats_title: 'STATISTICS',
  menu_stats: 'STATS',
  stats_levels_completed: 'Levels completed',
  stats_endless_best: 'Endless best',
  stats_best_streak: 'Best streak',
  stats_fail_rate: 'Fail rate',
  stats_wins: 'Wins',
  stats_fails: 'Fails',
  stats_hints_used: 'Hints used',
  stats_ads_watched: 'Ads watched',
  stats_close: 'CLOSE',
  // ── Added with the redesign (machine draft, see TRANSLATIONS-DRAFT.md) ──
  result_map_tapped: '你的点击',
  result_map_broke: '在此失败',
  result_map_answer: '正解',
  result_show_answer: '查看答案',
  menu_endless_line: '自动生成的关卡，三条命。越深越难。',
  menu_best: '最高 LV {n}',
  menu_best_streak: '最高 LV {n}  ·  连胜 ×{s}',
  menu_resume: '继续 LV {n}',
  menu_start: '开始 LV 1',
  result_run_total: '本局总分 {n}',
  result_streak: '连胜 ×{n}',
  result_streak_wins: '连续获胜 {n} 次',
  legend_title: '图例',
  legend_nodes: '节点',
  legend_wires: '线路',
  legend_close: '点击任意位置关闭',
  settings_sync_now: '立即同步 ({who})',
  settings_sign_in: '登录以同步',
  settings_sign_out: '退出登录',

};
